import { logToSentry } from '@otovo/shared/lib/sentry';
import { Cloud$Market } from '@otovo/shared/types/cloudEnums';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import {
  Sanity$DocumentLink,
  Sanity$NavbarLink,
} from '@otovo/shared/types/sanityTypes';
import { routeToHref } from '../../SanityLandingPage/routeToHrefUtil';

export const getNavLinkUrl = (
  link: Sanity$DocumentLink | Sanity$NavbarLink,
  market: Cloud$Market,
  locale: Otovo$Locale,
): string | null => {
  if (link._type === 'sanityLink') {
    return routeToHref(link.route, market, locale);
  }
  if (link._type === 'navLink') {
    return link.href;
  }
  logToSentry(
    `getNavLinkUrl: Unsupported link type: ${(link as any)._type}. Expected 'sanityLink' or 'navLink'.`,
  );
  return null;
};

/**
 * This function extracts optional properties from a link object. This is to satisfy TypeScript's type checking.
 * It checks if the link is an object and if it contains 'target' or 'rel' properties.
 * If they exist, it returns them as an object; otherwise, it returns an empty object.
 *
 * We use this to ensure that we only pass these properties when they are defined,
 * @param link
 *
 * @returns An object containing 'target' and/or 'rel' properties if they exist, otherwise an empty object.
 */
export const getOptionalProps = (
  link: Sanity$NavbarLink | Sanity$DocumentLink,
) => {
  if (!link || typeof link !== 'object') {
    return {};
  }
  return {
    ...(typeof link === 'object' && 'target' in link
      ? { target: link.target }
      : {}),
    ...(typeof link === 'object' && 'rel' in link ? { rel: link.rel } : {}),
  };
};
